






















































































import Vue from "vue";
import { cloneDeep, escape } from "lodash"
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { makeToast } from '@/modules/budget/monitoring/reports-constructor/common/utils/otherUtils'
import { nameMap } from '@/modules/budget/monitoring/reports-constructor/common/nameMap'
import { report127BaseTemplate } from "../../reports/report-1-27/report-127";
import { report127DailyBaseTemplate } from "../../reports/report-1-27-daily/report-127-daily";
import { Template } from "../../common/types/Template";
import { TemplateResponse } from "../../common/types/TemplateResponse";
import { application2BaseTemplate } from "../../reports/application-2/application-2";
import { ReportCategory } from "../../common/types/ReportCategory";
import { report420BaseTemplate } from "../../reports/4-20/report-4-20";
import { reportIncomeBaseTemplate } from "../../reports/report-income/report-income";
import { reportPlanCashBaseTemplate } from "../../reports/report-plan-cash/report-plan-cash";
import { reportIRBOBaseTemplate } from "../../reports/report-irbo/report-irbo";
import { reportDviBaseTemplate } from "../../reports/dvi/report-dvi";
import { reportIPIPMBaseTemplate } from "../../reports/ipipm/report-ipipm";
import { report127ActBaseTemplate } from "../../reports/report-1-27-act/report-127-act";
import { reportDkiRBaseTemplate } from "../../reports/dki-r/report-dki-r";
import { reportDkiPBaseTemplate } from "../../reports/dki-p/report-dki-p";
import { reportEibBaseTemplate } from "../../reports/eib/report-eib";
import { reportCashExecBaseTemplate } from "../../reports/report-cash-exec/report-cash-exec";
import { reportRsBaseTemplate } from "../../reports/rs/report-rs";
import { reportRtBaseTemplate } from "../../reports/rt/report-rt";
import { get127BatchAggregatedTemplate, get127BatchEconomicalTemplate, get127BatchFullTemplate, get127BatchCurrentProgramsTemplate, get127BatchDevelopProgramsTemplate, get127BatchIncomeExecutionTemplate, get127BatchExpenseExecutionTemplate, get127BatchAbpExecutionTemplate } from "../../reports/report-1-27/batch-export-templates";
import { svodPlanBaseTemplate } from "../../reports/svod-plan/report-svod-plan";
import { svodDohBaseTemplate } from "../../reports/svod-doh/report-svod-doh";
import { reportReconStatementBaseTemplate } from "../../reports/report-recon-statement/report-recon-statement";
import { reportBrBaseTemplate } from "../../reports/br/report-br";
import { reportMBSPBaseTemplate } from "../../reports/mbsp/report-mbsp";
import { reconPfKfBaseTemplate } from "../../reports/recon-pf-kf/report-recon-pf-kf";
import { report243BaseTemplate } from "../../reports/2-43/report-243";
import i18nService from "@/services/i18n";
import { loanStatusBaseTemplate } from "../../reports/loan-status/loan-status";
import { ksnBaseTemplate } from "../../reports/ksn/ksn";
import { reportSvodRasBaseTemplate } from "../../reports/svod-ras/svod-ras";
import { reportOwnIncomeBaseTemplate } from "../../reports/report-own-income/report-own-income";
import { svodMbBaseTemplate } from "../../reports/svod-mb/svod-mb";
import { kf219CoBaseTemplate } from "../../reports/kf219-co/report-kf219-co";

@Component({
    name: "report-list"
})
export default class ReportList extends Vue {

    // #region Props
    @Prop({
        type: Function,
        required: true,
    })
    public onSelectReport!: Function;


    @Prop({
        type: Object,
        required: true,
    })
    public availableReports!: Record<string, Record<string, string>>;

    @Prop({
        type: Boolean,
        required: true
    })
    public isIncomesAvailable!: boolean

    @Prop({
        type: Boolean,
        required: true
    })
    public isExpensesAvailable!: boolean

    // #endregion

    get userId() {
        return this.$store.getters.user_uuid
    }

    // #region Data
    public tempI18Service: any = null
    public templates: Template[] = [] 
    public reportCategories = [] as ReportCategory[]
    public totalExpand: boolean = false
    private readonly moduleCode = '005.003.007'
    private enviroment: string = ''
    private oblastKato: string = ''
    // #endregion

    // #region Computed
    get isAdmin(): boolean {
        const accessLevel = this.$store.state.user.userModules.find((it: any) => it.modules === this.moduleCode)?.access_level
        return accessLevel == 3
    }

    get visibleReportCategories(): ReportCategory[] {
        return this.reportCategories.filter(category =>
            category.code === null || this.templates.some(t => t.category === category.code)
        )
    }
    // #endregion
    isNewForm(templateId: number | null): boolean {
        return !templateId
    }
    private async created() {
        this.tempI18Service = i18nService
        try {
            await this.setEnviroment()
            await this.setOblastKato()
            await this.loadCategories()
            await this.loadTemplates()
        } catch (error) {
            console.log(error)
        }
    }

    private async setEnviroment() {
        try {
            const katoCode = this.$store.state._instanceCode
            const response = await fetch(`/api/dict/get-budget-obl?obl=${katoCode}`)
            if (!response.ok) {
                throw new Error('error')
            }
            const serverInfo = await response.json()
            this.enviroment = serverInfo.server
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_api_get_budget_obl'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    // #region Methods
    /** Метод-обертка для $t */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
        const text: string = String(this.$t(`${translationKey}.${key.toLowerCase()}`))

        return text
    }


    private async setOblastKato() {
        const response = await fetch('/api/dict/server-description')
        if (!response.ok) {
            throw new Error('error_load_env_failed')
        }
        const serverDescription = await response.text()

        if (serverDescription === 'release' || this.$store.state._instanceCode === '') {
            this.oblastKato = ''
        } else {
            this.oblastKato = this.$store.state._instanceCode
        }
    }

    public toggleAllCategoryVisibility(visibility: boolean) {
        this.totalExpand = visibility
        this.reportCategories.forEach(it => it.isExpanded = visibility)
    }

    private async loadCategories() {
        const response = await fetch('/api-py/monitoring/reports-constructor/report-categories')
        if (!response.ok) {
            throw new Error('error_api_get_categories_failed')
        }
        const categoriesData = await response.json()

        const reportCategories: ReportCategory[] = categoriesData.map((it: any) => {
            const temp: ReportCategory = {
                id: it.id,
                code: it.code,
                nameRu: it.name_ru,
                nameKk: it.name_kk,
                nameEn: it.name_en,
                isExpanded: false
            }
            return temp
        })
        const personalCategory: ReportCategory = {
            id: 0,
            code: null,
            nameRu: 'Личные шаблоны',
            nameKk: 'Жеке үлгілер',
            nameEn: 'Personal templates',
            isExpanded: false
        }
        reportCategories.push(personalCategory)

        this.reportCategories = reportCategories
    }

    private async loadTemplates() {
        try {
            const tempTemplates: Template[] = [
                // Исходные шаблоны:
                cloneDeep(report127BaseTemplate),
                cloneDeep(report127DailyBaseTemplate),
                // Removed 19.11.2025 due to task 8322
                // cloneDeep(application2BaseTemplate),
                cloneDeep(report420BaseTemplate),
                cloneDeep(reportIncomeBaseTemplate),
                cloneDeep(reportPlanCashBaseTemplate),
                cloneDeep(reportIRBOBaseTemplate),
                cloneDeep(reportDviBaseTemplate),
                cloneDeep(report127ActBaseTemplate),
                cloneDeep(reportDkiRBaseTemplate),
                cloneDeep(reportDkiPBaseTemplate),
                cloneDeep(reportEibBaseTemplate),
                cloneDeep(reportCashExecBaseTemplate),
                cloneDeep(reportRsBaseTemplate),
                cloneDeep(reportRtBaseTemplate),
                cloneDeep(svodPlanBaseTemplate),
                cloneDeep(svodDohBaseTemplate),
                cloneDeep(reportReconStatementBaseTemplate),
                cloneDeep(reportBrBaseTemplate),
                cloneDeep(reportIPIPMBaseTemplate),
                cloneDeep(reportMBSPBaseTemplate),
                cloneDeep(loanStatusBaseTemplate),
                cloneDeep(reconPfKfBaseTemplate),
                cloneDeep(report243BaseTemplate),
                cloneDeep(ksnBaseTemplate),
                cloneDeep(reportSvodRasBaseTemplate),
                cloneDeep(reportOwnIncomeBaseTemplate),
                cloneDeep(svodMbBaseTemplate),
                cloneDeep(kf219CoBaseTemplate),
            ]

            // 1-27 Шаблоны с пакетной выгрузкой:
            const currentDate = new Date()
            tempTemplates.push(get127BatchFullTemplate(currentDate))
            tempTemplates.push(get127BatchAggregatedTemplate(currentDate))
            tempTemplates.push(get127BatchEconomicalTemplate(currentDate))
            tempTemplates.push(get127BatchCurrentProgramsTemplate(currentDate))
            tempTemplates.push(get127BatchDevelopProgramsTemplate(currentDate))
            tempTemplates.push(get127BatchIncomeExecutionTemplate(currentDate))
            tempTemplates.push(get127BatchExpenseExecutionTemplate(currentDate))
            tempTemplates.push(get127BatchAbpExecutionTemplate(currentDate))

            // Пользовательские шаблоны:
            let katoCode = this.oblastKato
            if (!katoCode) {
                // '00' - Загружать все области, если НСИ или тестовая среда
                katoCode = '00'
            }
            const response = await fetch(`/api-py/monitoring/reports-constructor/templates/${this.userId}/${katoCode}`)
            if (!response.ok) {
                throw new Error('error_api_get_templates_failed')
            }
            const sharedAndPersonalTemplatesResponse: TemplateResponse[] = (await response.json())

            sharedAndPersonalTemplatesResponse.forEach(it => {
                const mapped: Template = {
                    id: it.id,
                    name: it.name,
                    excelName: it.excel_name,
                    description: it.description,
                    category: it.category,
                    regions: it.regions,
                    filterSettings: it.filter_settings,
                    userId: it.user_id
                }
                tempTemplates.push(mapped)
            })


            this.templates = tempTemplates.filter(t => {
                if (['CASH-EXEC'].includes(t.filterSettings.reportName)) {
                    return (this.isIncomesAvailable || this.isExpensesAvailable) && t.filterSettings.reportName in this.availableReports
                }
                return t.filterSettings.reportName in this.availableReports
            })
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_load_templates'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    public async deleteTemplate(id: number) {
        let katoCode = this.oblastKato
        if (!katoCode) {
            katoCode = '00'
        }

        const response = await fetch(`/api-py/monitoring/reports-constructor/templates/${katoCode}/${id}/${this.userId}`, {
            method: 'DELETE'
        })
        if (!response.ok) {
            makeToast(this, this.tr('toasts.' + 'error_delete_template'), this.tr('toasts.' + 'error'), 'danger')
            return
        }
        makeToast(this, this.tr('toasts.' + 'template_deleted'), this.tr('toasts.' + 'message_title'), 'success')

        await this.loadTemplates()
    }
    private getReportCategoryName(category: ReportCategory) : string {
        switch (this.tempI18Service.locale) {
            case 'kk':
                return category.nameKk || category.nameRu || '';
            case 'en':
                return category.nameEn || category.nameRu || '';
            case 'ru':
            default:
                return category.nameRu || '';
        }
    }

    private getReportName(reportName: string, categoryCode: number, untranslatedReportName: string) : string {
        if (!(reportName in this.availableReports)) {
            return untranslatedReportName || ''
        }
        if (categoryCode != 70 || reportName === '1-27-ACT') {
            switch (this.tempI18Service.locale) {
                case 'kk':
                    return this.availableReports[reportName]['name_kk'] || untranslatedReportName || '';
                case 'en':
                    return this.availableReports[reportName]['name_en'] || untranslatedReportName || '';
                case 'ru':
                default:
                    return this.availableReports[reportName]['name_ru'] || untranslatedReportName || '';
            }
        } else if (categoryCode == 70 && reportName === '1-27') {
            return this.tr('1_27.templates.' + untranslatedReportName)
        }
        else {
            return untranslatedReportName
        }
    }

    //#endregion

    public readonly nameMap = nameMap
}
